/**
 * Determine if stars and text should be reduced
 * @param {boolean} reduceBasedOnLikes
 * @param {boolean} reduceBasedOnScreenSize
 * @param {boolean} isQuickShop
 * @returns {boolean}
 */
const shouldReduceStarsAndTrimTextUtil = (reduceBasedOnLikes, reduceBasedOnScreenSize, isQuickShop) => {
  if (isQuickShop) {
    return false
  }
  return reduceBasedOnLikes || reduceBasedOnScreenSize
}

export default shouldReduceStarsAndTrimTextUtil
